import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonV2Component } from '../../../shared/components/button-v2/button-v2.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';

@Component({
  selector: 'app-connection-expired-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonV2Component, IconComponent],
  templateUrl: './connection-expired-modal.component.html',
  styleUrls: ['./connection-expired-modal.component.scss'],
})
export class ConnectionExpiredModalComponent {
  onReload(): void {
    window.location.reload();
  }
}
